export default __webpack_public_path__ + "static/media/03clock.39b2d8a6.jpg";